<template>
  <q-layout view="lHh Lpr lFf">
    <q-header elevated class="glossy">
      <q-toolbar>
        <q-btn
          flat
          dense
          round
          @click="leftDrawerOpen = !leftDrawerOpen"
          aria-label="Menu"
          icon="menu"
        />

        <q-toolbar-title>
          Firmas layout
        </q-toolbar-title>

        <div>Q v{{ $q.version }}</div>
      </q-toolbar>
    </q-header>

    <q-drawer
      v-model="leftDrawerOpen"
      bordered
      content-class="bg-grey-2"
    >
      <q-list>
        <q-item-label header>Menu Firmas</q-item-label>
        <q-item v-for="item in menu"
            clickable 
            tag="a" 
            exact
            :key="item.label"
            :to="{name:item.name}">

            <q-item-section avatar>
              <q-icon :name="item.icon" />
            </q-item-section>
            <q-item-section>
              <q-item-label>{{item.label}}</q-item-label>
              <q-item-label caption>{{item.caption}}</q-item-label>
            </q-item-section>
          </q-item>
        
      </q-list>
    </q-drawer>

    <q-page-container>
      <router-view/>
    </q-page-container>
  </q-layout>
</template>

<script>
import {userService} from '@/_services/user.service';
import {mapGetters} from 'vuex';

export default {
  name: 'LayoutOtro',

  components: {
    
  },

  data () {
    return {
      // leftDrawerOpen: this.$q.platform.is.desktop,
      leftDrawerOpen: false,
      menu: [
        {
          label: 'Inicio',
          icon: 'view_list',
          to: 'xx',
          name: 'home',
          caption: 'inicio'
        },
        {
          label: 'Firma',
          icon: 'view_list',
          to: 'xx',
          name: 'firma',
          caption: 'firma'
        },
        {
          label: 'Firma2',
          icon: 'view_list',
          to: 'xx',
          name: 'firma2',
          caption: 'firma clear, dialog'
        },
        {
          label: 'Firma3',
          icon: 'view_list',
          to: 'xx',
          name: 'firma3',
          caption: 'dialogo maximizado'
        },        {
          label: 'Flex',
          icon: 'view_list',
          to: 'xx',
          name: 'flexbox',
          caption: 'pruebas'
        }
      ],
    }
  },

  computed: {
    ...mapGetters(['isAuthenticated', 'getToken'])
  },
  methods: {
    // pasar a actions
    logout() {
      userService.logout()
      .then( data => {
        console.log('logout menu layout: ', data);
        this.$store.commit('setUser', {token: ''})
        this.$router.push({name: 'home'});
      })
      
    }
  }
}
</script>

<style>
</style>
